import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { groupBy } from '../../../../server/util';
import './monthCalender.css';
const weekEndDays = ['Sun', 'Sat'];
const MealTypesText = {
    MEAL: 'Main course',
    SNACK: 'Snack',
    DINNER: 'Dinner',
    BREAKFAST: 'Breakfast',
    SIDE: 'Sides',
    EXTRA: 'A La Carte ',
    HOLIDAY: 'Holiday'
}
const MealTypes = {
    meal: 'MEAL',
    snack: 'SNACK',
    dinner: 'DINNER',
    breakfast: 'BREAKFAST',
    side: 'SIDE',
    extra: 'EXTRA',
    holiday: 'HOLIDAY'
};

class MonthCalender extends Component {
    renderDayEventList = (eventDate) => {
        const { currency_symbol, events, renderDayEventList, eventClick } = this.props;
        const groupByDate = groupBy(events, 'date');
        const groupByType = groupBy((groupByDate[eventDate.format('YYYY-MM-DD')] || []).map(itm => {
            if (itm.type == MealTypes.meal || itm.type == MealTypes.breakfast
                || itm.type == MealTypes.snack || itm.type == MealTypes.dinner
            ) {
                itm.type = 'ENTREE';
            }
            return itm;
        }), 'type');
        const isDisabled = false;
        if (renderDayEventList) {
            return renderDayEventList(groupByType, eventDate);
        } else {
            return (
                <Fragment>
                    {
                        (groupByType[MealTypes.meal] || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[MealTypes.meal]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (groupByType[MealTypes.meal] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                        return <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")} onClick={() => {
                                            if (eventClick) {
                                                this.props.eventClick(item);
                                            }
                                        }}>
                                            <span>{item.name}</span></div>
                                    })
                                }
                            </Fragment> : null
                    }
                    {
                        (groupByType[MealTypes.snack] || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[MealTypes.snack]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (groupByType[MealTypes.snack] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                        return <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")} onClick={() => {
                                            if (eventClick) {
                                                this.props.eventClick(item);
                                            }
                                        }}>
                                            <span>{item.name}</span></div>
                                    })
                                }
                            </Fragment> : null
                    }
                    {
                        (groupByType[MealTypes.dinner] || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[MealTypes.dinner]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (groupByType[MealTypes.dinner] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                        return <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")} onClick={() => {
                                            if (eventClick) {
                                                this.props.eventClick(item);
                                            }
                                        }}>
                                            <span>{item.name}</span></div>
                                    })
                                }
                            </Fragment> : null
                    }
                    {
                        (groupByType[MealTypes.breakfast] || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[MealTypes.breakfast]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (groupByType[MealTypes.breakfast] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                        return <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")} onClick={() => {
                                            if (eventClick) {
                                                this.props.eventClick(item);
                                            }
                                        }}>
                                            <span>{item.name}</span></div>
                                    })
                                }
                            </Fragment> : null
                    }
                    {
                        (groupByType[MealTypes.side] || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[MealTypes.side]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (groupByType[MealTypes.side] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                        return <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")} onClick={() => {
                                            if (eventClick) {
                                                this.props.eventClick(item);
                                            }
                                        }}>
                                            <span>{item.name}</span></div>
                                    })
                                }
                            </Fragment> : null
                    }{
                        (groupByType[MealTypes.extra] || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[MealTypes.extra]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (groupByType[MealTypes.extra] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                        return <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")} onClick={() => {
                                            if (eventClick) {
                                                this.props.eventClick(item);
                                            }
                                        }}>
                                            <span>{item.name}</span></div>
                                    })
                                }
                            </Fragment> :
                            null
                    }
                    {
                        (groupByType[MealTypes.holiday] || []).length > 0 ?
                            <Fragment>
                                {(groupByType[MealTypes.holiday] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    return <div className={"menuItem noSchool"}>
                                        <span>{item.name}</span></div>
                                })
                                }
                            </Fragment> : null
                    }
                </Fragment>
            )

        }

    }
    buildCalender = () => {
        let firstDay = moment([this.props.defaultDate.get('year'), this.props.defaultDate.get('month'), 1]).day();
        let daysInMonth = parseInt(this.props.defaultDate.endOf('month').format('DD'));
        let date = 1;
        return (
            <table style={{ marginBottom: '16vh' }} className="table table-bordered table-responsive" id="calendar">
                <thead>
                    <tr className="bg-color-1 tblHead">
                        {
                            [0, 1, 2, 3, 4, 5, 6].map(i => {
                                return (this.props.hiddenDays || []).includes(i) ?
                                    <th className="col-lg-2" style={{ display: 'none' }}>{moment().day(i).format('ddd')}</th> :
                                    <th className="col-lg-2">{moment().day(i).format('ddd')}</th>
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        [0, 1, 2, 3, 4, 5].map((i) => {
                            return (<tr>{
                                [0, 1, 2, 3, 4, 5, 6].map((j) => {
                                    const thisDate = moment([this.props.defaultDate.get('year'), this.props.defaultDate.get('month'), date])
                                    if (i === 0 && j < firstDay) {
                                        return (this.props.hiddenDays || []).includes(j) ? <td style={{ display: 'none' }}></td> : <td className="tblBodyCol">{''}</td>
                                    } else if (date > daysInMonth) {
                                        return null
                                    } else {
                                        const _str = (this.props.hiddenDays || []).includes(j) ?
                                            <td style={{ display: 'none' }}></td> :
                                            <td className="tblBodyColDate">
                                                <span className={thisDate.format('YYYYMMDD') == moment().format('YYYYMMDD') ? 'today' : 'notToday'}>{date}</span>
                                                {
                                                    this.renderDayEventList(thisDate)
                                                }
                                            </td>
                                        date++;
                                        return _str;
                                    }

                                })
                            }</tr>);
                        })
                    }
                </tbody>
            </table>
        )

    }
    render() {
        return (
            <div>
                {
                    this.buildCalender()
                }

            </div>
        )
    }
}

export default MonthCalender



// WEBPACK FOOTER //
// ./src/components/Misc/calender/monthCalender/monthCalender.jsx